var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"cols":"12","md":"3"}},[_c('member-sidebar',{staticClass:"bg-dark",attrs:{"route-name":_vm.$route.name}})],1),_c('b-col',{attrs:{"cols":"12","md":"9"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }